import './nav.css'
import { Link, useLocation, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dot, ScrollText, Settings, UserRoundCog, HandCoins, Megaphone, Wallet, ChevronDown, ChevronUp, Gift, Image, LoaderPinwheel } from 'lucide-react';

function Sidebar() {
    let location = useLocation();

    let dark = useSelector((state) => state.Darkmode.value);

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);  // "로그" 드롭다운
    const [isWalletOpen, setIsWalletOpen] = useState(false);      // "q-Wallet" 드롭다운

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    const toggleWalletDropdown = () => {
        setIsWalletOpen((prev) => !prev);
    };

    const darkname = dark ? "dark" : "";

    const [loca, setLoca] = useState(0);

    useEffect(() => {
        if (location) {
            // if (location.pathname == '/dashboard') setLoca(0)
            if (location.pathname === "/member") setLoca(1);
            // else if (location.pathname == '/airdrop') setLoca(2)
            else if (location.pathname === "/advertisement") setLoca(3);
            else if (location.pathname === "/character") setLoca(4);
            else if (location.pathname === "/gameSetting") setLoca(5);
            else if (location.pathname === "/adminSetting") setLoca(6);
            else if (location.pathname === "/upgradeSetting") setLoca(7);
            else if (location.pathname === "/jactpotSetting") setLoca(8);
            else if (location.pathname === "/touchImg") setLoca(9);
            else if (location.pathname === "/soundManage") setLoca(10);
            // else if (location.pathname === "/notice") setLoca(11);

            else if (location.pathname === "/common") setLoca(20);
            else if (location.pathname === "/network") setLoca(21);
            else if (location.pathname === "/token") setLoca(22);
            else if (location.pathname === "/eventBanner") setLoca(23);

            else if (location.pathname === "/logJackpot") setLoca(30);
            else if (location.pathname === "/logAccess") setLoca(31);
            else if (location.pathname === "/logGold") setLoca(32);
            else if (location.pathname === "/logEnergy") setLoca(33);
            else if (location.pathname === "/logAirdrop") setLoca(34);

            else if (location.pathname === "/example") setLoca(50);

            else setLoca(1);

            // 로그 드롭다운
            if ([30, 31, 32, 33, 34, 35, 36].includes(loca)) {
                setIsDropdownOpen(true);
            } else {
                setIsDropdownOpen(false);
            }

            // q-Wallet 드롭다운
            if ([20, 21, 22, 23].includes(loca)) {
                setIsWalletOpen(true);
            } else {
                setIsWalletOpen(false);
            }
        }
    }, [location, loca]);

    return (
        <div className={`sidebar ${darkname}`}>
            <div className="sidebar-box">
                <Link to={`/member`}>
                    <div className={loca === 1 ? `sidebar-box-1 on  ${darkname}` : `sidebar-box-1 ${darkname}`}>
                        <UserRoundCog />
                        <div className="sidebar-box-1-1">유저 관리</div>
                    </div>
                </Link>
                <Link to={`/gameSetting`}>
                    <div className={loca === 5 ? `sidebar-box-1 on  ${darkname}` : `sidebar-box-1 ${darkname}`}>
                        <Settings />
                        <div className="sidebar-box-1-1">기본 설정</div>
                    </div>
                </Link>
                <Link to={`/jactpotSetting`}>
                    <div className={loca === 8 ? `sidebar-box-1 on  ${darkname}` : `sidebar-box-1 ${darkname}`}>
                        <HandCoins />
                        <div className="sidebar-box-1-1">잭팟 설정</div>
                    </div>
                </Link>
                <Link to={`/advertisement`}>
                    <div className={loca === 3 ? `sidebar-box-1 on  ${darkname}` : `sidebar-box-1 ${darkname}`}>
                        <Megaphone />
                        <div className="sidebar-box-1-1">광고</div>
                    </div>
                </Link>

                <div className="sidebar-box-2">
                    <Link to={`/upgradeSetting`}>
                        <div className={loca === 4 || loca === 7 || loca === 9 ? `sidebar-box-1 on  ${darkname}` : `sidebar-box-1 ${darkname}`}>
                            <Settings />
                            <div className="sidebar-box-1-1">게임 설정</div>
                        </div>
                    </Link>
                    <div className={`sidebar-box-1-2 ${darkname}`}>
                        <Link to={`/upgradeSetting`} style={{ width: "100%" }}>
                            <div className={loca === 7 ? "on" : ""}>
                                <Dot />
                                강화 관리
                            </div>
                        </Link>
                        <Link to={`/character`} style={{ width: "100%" }}>
                            <div className={loca === 4 ? "on" : ""}>
                                <Dot />
                                캐릭터 관리
                            </div>
                        </Link>
                        <Link to={`/touchImg`} style={{ width: "100%" }}>
                            <div className={loca === 9 ? "on" : ""}>
                                <Dot />
                                화면 관리
                            </div>
                        </Link>
                        <Link to={`/soundManage`} style={{ width: "100%" }}>
                            <div className={loca === 10 ? "on" : ""}>
                                <Dot />
                                사운드 관리
                            </div>
                        </Link>
                    </div>
                </div>
                {/* <Link to={`/notice`}>
                    <div className={loca === 11 ? `sidebar-box-1 on  ${darkname}` : `sidebar-box-1 ${darkname}`}>
                        <Image />
                        <div className="sidebar-box-1-1">팝업이미지</div>
                    </div>
                </Link> */}

                {/* q-Wallet 설정 (드롭다운) */}
                <div className="sidebar-box-2">
                    <div
                        className={
                            [20, 21, 22, 23].includes(loca)
                                ? `sidebar-box-1 on ${darkname}`
                                : `sidebar-box-1 ${darkname}`
                        }
                        onClick={toggleWalletDropdown}
                        style={{ cursor: "pointer" }}
                    >
                        <Wallet />
                        <div className="sidebar-box-1-1" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <span>q-Wallet 설정</span>
                            {isWalletOpen ? <ChevronUp size={15} /> : <ChevronDown size={15} />}
                        </div>
                    </div>
                    {isWalletOpen && (
                        <div className={`sidebar-box-1-2 ${darkname}`}>
                            <Link to={`/common`} style={{ width: "100%" }}>
                                <div className={loca === 20 ? "on" : ""}>
                                    <Dot />
                                    공통 설정
                                </div>
                            </Link>
                            <Link to={`/network`} style={{ width: "100%" }}>
                                <div className={loca === 21 ? "on" : ""}>
                                    <Dot />
                                    네트워크 설정
                                </div>
                            </Link>
                            <Link to={`/token`} style={{ width: "100%" }}>
                                <div className={loca === 22 ? "on" : ""}>
                                    <Dot />
                                    토큰 설정
                                </div>
                            </Link>
                            <Link to={`/eventBanner`} style={{ width: "100%" }}>
                                <div className={loca === 23 ? "on" : ""}>
                                    <Dot />
                                    이벤트 배너
                                </div>
                            </Link>
                        </div>
                    )}
                </div>

                {/* 로그 (드롭다운) */}
                <div className="sidebar-box-2">
                    <div
                        className={
                            [30, 31, 32, 33, 34, 35, 36].includes(loca)
                                ? `sidebar-box-1 on ${darkname}`
                                : `sidebar-box-1 ${darkname}`
                        }
                        onClick={toggleDropdown}
                        style={{ cursor: "pointer" }}
                    >
                        <ScrollText />
                        <div className="sidebar-box-1-1" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <span>로그</span>
                            {isDropdownOpen ? <ChevronUp size={15} /> : <ChevronDown size={15} />}
                        </div>
                    </div>
                    {isDropdownOpen && (
                        <div className={`sidebar-box-1-2 ${darkname}`}>
                            <Link to={`/logAccess`} style={{ width: "100%" }}>
                                <div className={loca === 31 ? "on" : ""}>
                                    <Dot />
                                    접속 로그
                                </div>
                            </Link>
                            <Link to={`/logGold`} style={{ width: "100%" }}>
                                <div className={loca === 32 ? "on" : ""}>
                                    <Dot />
                                    다이아 로그
                                </div>
                            </Link>
                            <Link to={`/logEnergy`} style={{ width: "100%" }}>
                                <div className={loca === 33 ? "on" : ""}>
                                    <Dot />
                                    에너지 로그
                                </div>
                            </Link>
                            <Link to={`/logJackpot`} style={{ width: "100%" }}>
                                <div className={loca === 30 ? "on" : ""}>
                                    <Dot />
                                    잭팟 로그
                                </div>
                            </Link>
                            <Link to={`/logAirdrop`} style={{ width: "100%" }}>
                                <div className={loca === 34 ? "on" : ""}>
                                    <Dot />
                                    에어드랍 로그
                                </div>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;